// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__XV1Pp","breadcrumb":"Breadcrumb_breadcrumb__uBceH"};